export const MODULE_ID = 'organization';
export const ORGANIZATIONS_PER_PAGE = 5;
export const ORGANIZATION_SEARCH_DEBOUNCE = 300;
export const CREATE_MODAL = `${MODULE_ID}/createModal`;
export const JOIN_MODAL = `${MODULE_ID}/joinModal`;
export const LEAVE_MODAL = `${MODULE_ID}/leaveModal`;
export const JOIN_FORM = `${MODULE_ID}.joinForm`;
export const CREATE_FORM = `${MODULE_ID}.createForm`;
export const CREATE_ORGANIZATION_FORM = `${MODULE_ID}.createOrganizationForm`;
export const SEARCH_ORGANIZATION_FORM = `${MODULE_ID}.searchOrganizationForm`;
